import { yupResolver } from "@hookform/resolvers/yup";
import { BackgroundEraserFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";
import { defaultFormValues as _defaultFormValues } from "./constants";

export interface BackgroundEraserFormProps {
  defaultFormValues?: Partial<BackgroundEraserFormValues>;
  children?: React.ReactNode;
}

export const BackgroundEraserForm = ({
  defaultFormValues,
  children,
}: BackgroundEraserFormProps) => {
  const methods = useForm<BackgroundEraserFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
